import styled from "styled-components";
import { color } from "../../styles";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

interface SearchBarWrapperProps {
  isFocus: Boolean;
}

export const BoxWrapper = styled.div<{ $disabled?: boolean }>`
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding-left: 12px;
  padding-right: 10px;
  border: 1px solid ${color.secondary.GREY_4};
  background-color: ${color.emphasis.NEUTRAL_N5};
  height: 34px;
  max-width: 655px;
  align-items: center;
  border-radius: 5px;
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};

  &:hover {
    cursor: pointer;
    border-color: ${color.secondary.GREY_4};
  }
`;

export const StyledMenu = styled(Menu)`
  & .MuiPaper-root {
    padding: 12px;
    display: flex;
    flex-direction: column;
    border: 1px solid ${color.secondary.GREY_4};
    box-shadow: 0 1px 4px rgba(0,0,0,0.05);
    border-radius: 5px;
    box-sizing: border-box;
    justify-content: flex-start;
    margin-top: 6px;
  }
`;

export const SearchBarWrapper = styled.div<SearchBarWrapperProps>`
  padding: 8px 12px;
  border: solid 1px
    ${(props: SearchBarWrapperProps) =>
      props.isFocus ? color.secondary.CHARCOAL : color.emphasis.NEUTRAL_N30};
  border-radius: 40px;
  display: flex;
  gap: 12px;
  width: auto;
  margin-bottom: 8px;
`;

export const SearchText = styled.input`
  color: ${color.secondary.CHARCOAL};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  width: 100%;
  border: none;

  &::placeholder {
    color: ${color.emphasis.NEUTRAL_N30};
  }

  &:focus {
    border: none;
    box-shadow: none;
    outline: none;
  }
`;

export const MenuContainer = styled.div`
  max-height: 250px;
  overflow-y: auto;
  margin-top: 8px;
`;

export const CustomMenuItem = styled(MenuItem)`
  && {
    display: flex;
    align-items: center;
    width: 100%;
    cursor: pointer;
    padding: 8px 12px;
    border-radius: 4px;
    margin-bottom: 4px;

    &:hover {
      color: ${color.primary.BLUE_B100};
      background-color: rgba(0, 0, 0, 0.04);
    }

    font-size: 14px;
    line-height: 20px;

    &:last-child {
      margin-bottom: 0;
    }
    
    &:focus {
      background: none;

      &:hover {
        background: rgba(0, 0, 0, 0.04);
      }
    }
  }
`;